<template>
  <div v-if="!mobile" class="register">
    <span class="ball ball-1"></span>
    <span class="ball ball-2"></span>
    <span class="ball ball-3"></span>
    <span class="ball ball-4"></span>
    <span class="ball ball-5"></span>
    <ul>
      <li><span class="ball"></span></li>
      <li><span class="ball"></span></li>
      <li><span class="ball"></span></li>
      <li><span class="ball"></span></li>
    </ul>
    <div class="register-body flex">
      <div class="register-bg bd flex-center column">
        <div class="register-slogan">
          <div>AIOT</div>
          <div class="text-nowrap text-bold">全新一代物联网内核引擎</div>
        </div>
        <div class="bottom-line"></div>
      </div>
      <el-form ref="registerForm" v-loading="loading" :model="registerForm" :rules="registerRules" class="register-form ft" auto-complete="off" size="big" status-icon label-position="left">
        <div class="title">{{ '欢迎注册' }}</div>
        <div class="register-content">
          <template v-if="scanCode">
            <div class="phone-number">
              {{ phoneNumber }}
            </div>
            <el-form-item prop="username">
              <el-popover placement="right-start" width="285" trigger="click">
                <li>4-50个字符，可以使用英文字母、数字和特殊字符</li>
                <li>请勿包含身份证银行卡等隐私信息，一旦设置成功无法修改</li>
                <el-input slot="reference" v-model="registerForm.username" placeholder="请设置用户名称" prefix-icon="el-icon-user" clearable type="text" @input="checkUsername" />
              </el-popover>
            </el-form-item>
            <el-form-item prop="pw">
              <el-popover placement="right-start" width="285" trigger="click">
                <li>6-20个字符，密码不能和用户名称相同</li>
                <li>只能包含字母、数字以及标点符号（除空格）</li>
                <el-input slot="reference" v-model="registerForm.pw" placeholder="请设置登录密码" prefix-icon="el-icon-lock" clearable />
              </el-popover>
            </el-form-item>
            <el-form-item prop="company">
              <el-input v-model="registerForm.company" placeholder="请输入公司名称" prefix-icon="el-icon-office-building" clearable />
            </el-form-item>
            <el-form-item>
              <el-button class="submit" type="primary" :loading="postLoading" @click="submitRegist()">注册</el-button>
            </el-form-item>
          </template>
          <template v-else>
            <div class="description">
              <span v-if="errorMsg" class="text-danger">{{ errorMsg }}</span>
              <span v-else>请使用微信扫码注册</span>
            </div>
            <div v-loading="qrcodeLoading" class="img-box flex align-items-center justify-content-center">
              <el-image v-if="qrcodeImg" class="img" :src="qrcodeImg" alt="" />
              <div v-if="showMask" class="mask">
                <el-button class="is-registed-btn" type="text" @click="getCode">刷新二维码</el-button>
              </div>
            </div>
          </template>
        </div>
        <div class="register-footer flex justify-content-center">
          <span class="text-muted">
            <span>已有账号？</span>
            <el-button class="relogin-btn" type="text" @click="handleRelogin">立即登录</el-button>
          </span>
        </div>
      </el-form>
    </div>
  </div>
  <SuggestToPC v-else />
</template>

<script>
import { validateRamUsername } from '@/utils/validate'
import { usernameCheckApi, registerApi, getQrCodeStatusApi, codeSendApi, getRegisterSettingApi } from '@/api/common/registerApi'
import { getQrcodeApi } from '@/api/ei/eiApi'
import { mobileFilter } from '@/utils/common'

export default {
  name: 'Register',

  data () {
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户名称不能为空'))
      } else {
        if (this.usernameMsg) callback(new Error(this.usernameMsg))
        if (validateRamUsername(value)) {
          callback()
        } else {
          return callback(new Error('用户名称只能由英文字母/数字/特殊字符组成'))
        }
      }
    }

    var validatePass = (rule, value, callback) => {
      if (value === this.registerForm.username) callback(new Error('请勿将用户名称设为密码'))
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (validateRamUsername(value)) {
          callback()
        } else {
          return callback(new Error('密码格式不正确！'))
        }
      }
    }

    return {
      loading: false,
      postLoading: false,

      usernameMsg: '',
      registerForm: {
        username: '',
        pw: '',
        mobile: '',
        code: null,
        company: '',
        verify_way: 2
      },
      registerRules: {
        username: [
          { min: 4, max: 50, message: '名称长度应在 4 到 50 个字符', trigger: 'blur' },
          { validator: validateUsername, trigger: 'blur' }
        ],
        pw: [
          { min: 6, max: 20, message: '密码长度不正确', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
      },

      mq: null,
      mobile: false,
      phoneNumber: '',
      scanCode: false,
      qrcodeImg: '',
      qrcodeLoading: false,
      timer: null,
      showMask: false,
      errorMsg: '',
    }
  },

  components: {
    SuggestToPC: () => import("@/views/common/components/SuggestToPC.vue")
  },

  created () {
    this.fetchRegisterSetting()
    this.getCode()
  },

  mounted () {
    this.mq = window.matchMedia('(max-width: 900px)')
    this.mq.addEventListener('change', this.checkDeviceType)
    this.checkDeviceType(this.mq)
  },

  beforeDestroy () {
    if (this.mq) {
      this.mq.removeEventListener('change', this.checkDeviceType)
    }
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    fetchRegisterSetting () {
      getRegisterSettingApi().then((res) => {
        if (!res.errno) {
          if (!res.data.aiot_register_enable) this.handleRelogin()
        }
      })
    },

    fetchQrcode () {
      this.qrcodeLoading = true
      getQrcodeApi({
        scene: `scene=1&code=${this.registerForm.code}`,
        path: 'pages/index/authorization',
        type: 'asst',
      }).then((res) => {
        if (!res.errno) {
          const base64 = btoa(String.fromCharCode(...new Uint8Array(res)));
          const imgUrl = `data:image/png;base64,${base64}`;
          this.qrcodeImg = imgUrl
          this.qrcodeLoading = false

          this.timer = setInterval(() => {
            this.fetchQrCodeStatus()
          }, 2000)
        } else {
          this.qrcodeLoading = false
        }
      }).catch(() => {
        this.qrcodeLoading = false
      })
    },

    fetchQrCodeStatus () {
      getQrCodeStatusApi({ verify_code: this.registerForm.code }).then((res) => {
        if (!res.errno) {
          if (res.data) {
            this.showMask = res.data.is_registed
            clearInterval(this.timer)

            if (res.data.is_registed) {
              this.errorMsg = res.data.err_msg
            } else {
              this.$message.success('授权成功！')
              this.phoneNumber = mobileFilter(res.data.mobile)
              this.registerForm.mobile = res.data.mobile
              this.scanCode = true
            }
          }
        } else {
          this.errorMsg = res.message
          this.showMask = true
          clearInterval(this.timer)
        }
      }).catch(() => {
        this.errorMsg = '获取二维码失败'
        this.showMask = true
        clearInterval(this.timer)
      })
    },

    getCode() {
      this.qrcodeLoading = true
      this.resetQrcode()
      codeSendApi({
        verify_way: 2,
        scene: 1
      }).then((res) => {
        if (!res.errno) {
          this.registerForm.code = res.data.verify_code
          this.fetchQrcode()
        } else {
          this.qrcodeLoading = false
        }
      }).catch(() => {
        this.qrcodeLoading = false
      })
    },

    resetQrcode () {
      this.qrcodeImg = ''
      this.showMask = false
      this.errorMsg = ''
    },

    handleRelogin () {
      this.$router.replace('/login')
    },

    checkUsername () {
      usernameCheckApi({ username: this.registerForm.username }).then((res) => {
        if (res.errno) {
          this.usernameMsg = res.message
        } else {
          this.usernameMsg = ''
        }
      })
    },

    submitRegist () {
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          this.postLoading = true
          registerApi(this.registerForm).then((res) => {
            if (!res.errno) { // 注册成功后直接进行登录api调用并跳转至快速入门
              this.postLoading = false
              this.$message.success('注册成功！请重新登录')
              this.handleRelogin()
              // const loginForm = {
              //   username: this.registerForm.username,
              //   password: this.registerForm.pw
              // }

              // this.$store.dispatch('loginByUsernameAction', loginForm).then((res) => {
              //   if (!res.errno) {
              //     this.$message.success(`欢迎登录，${loginForm.username}`)
              //     this.$router.push({ path: '/' })
              //   }
              // })
            } else {
              this.postLoading = false
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    checkDeviceType(e) {
      if (e.matches && /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        this.mobile = true
      } else {
        this.mobile = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.register {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background-color: #f9fffc;
  background-size: 100% auto;

  .ball {
    position: absolute;
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
    background-size: 100% auto;
  }
  .ball.ball-1 {
    top: 40px;
    left: 50%;
    width: 120px;
    height: 120px;
    transform: translateX(-50%) rotate(-180deg);
  }
  .ball.ball-2 {
    top: -120px;
    left: -50px;
    transform: rotate(100deg);
    width: 320px;
    height: 320px;
  }
  .ball.ball-3 {
    display: none;
    top: 120px;
    right: 15%;
    width: 120px;
    height: 120px;
    transform: rotate(-90deg);
  }
  .ball.ball-4 {
    top: 35%;
    right: 60px;
    width: 120px;
    height: 120px;
    transform: rotate(270deg);
  }
  .ball.ball-5 {
    top: 35%;
    left: 60px;
    width: 40px;
    height: 40px;
    transform: rotate(270deg);
    background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    opacity: 1;
  }
  .register-body {
    position: absolute;
    display: flex;
    z-index: 999;
    height: 490px;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    background-color: transparent;
    border-radius: 5px;
    .register-bg {
      height: 100%;
      position: relative;
      font-size: 48px;
      padding-right: 150px;
      .bottom-line{
        z-index: -1;
        margin-top: -15px;
        width: 100%;
        height: 25px;
        background: linear-gradient(87.21deg, rgba(40,167,69,0) 10.49%,rgba(40,167,69,0.8) 100.88%);
      }
    }
    .register-form {
      display: flex;
      flex-direction: column;
      text-align: center;
      box-sizing: border-box;
      padding: 30px 35px;
      width: 400px;
      background-color: #fff;
      box-shadow: -2px 8px 50px 0px rgba(238, 240, 240, 1);
      border-radius: 10px;
      .title {
        font-size: 28px;
        font-weight: bold;
        letter-spacing: 5px;
        color: #101010;
        margin-bottom: 35px;
      }
      .register-content {
        flex: 1;
      }
      .register-footer {
        margin-top: auto;
      }
      .phone-number {
        font-size: 28px;
        color: #101010;
        margin-bottom: 25px;
      }
      .description {
        height: 20px;
        font-size: 14px;
        color: #101010;
      }
      .img-box {
        position: relative;
        height: calc(100% - 20px);

        .img {
          width: 220px;
          height: 220px;
        }

        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: #fff;
          opacity: 0.96;
        }
        .is-registed-btn {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }

      .el-input {
        .el-input__inner {
          background: transparent;
          color: #fff;
          font-size: 16px;
        }
        .el-input__prefix {
          font-size: 18px;
        }
      }
      .submit {
        width: 100%;
        margin-top: 50px;
        border-radius: 30px;
        letter-spacing: 5px;
        font-size: 16px;
      }
      .relogin-btn {
        color: #07c160;
        margin-top: -22px;
      }
    }
  }

  ul {
    width: 80vw;
    height: 80vw;
    margin: 40px auto;
    position: relative;
    list-style: none;
  }
  ul li {
    border: 2px solid #ceedd79f;
    position: absolute;
    left: 50%;
    top: 60%;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: orbit;
  }
  ul li .ball {
    display: block;
    position: absolute;
    left: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-size: 100% auto;
  }
  ul li:nth-child(1) {
    width: 30%;
    height: 30%;
    animation-duration: 14s;
  }
  ul li:nth-child(1) .ball {
    left: 20%;
    top: 2%;
    width: 40px;
    height: 40px;
  }
  ul li:nth-child(2) {
    width: 50%;
    height: 50%;
    animation-duration: 16s;
  }
  ul li:nth-child(2) .ball {
    left: 75%;
    top: 5%;
    width: 60px;
    height: 60px;
  }
  ul li:nth-child(3) {
    width: 60%;
    height: 60%;
    animation-duration: 28s;
  }
  ul li:nth-child(3) .ball {
    width: 80px;
    height: 80px;
    left: 10%;
    top: 10%;
    background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    opacity: 1;
  }
  ul li:nth-child(4) {
    width: 100%;
    height: 100%;
    animation-duration: 45s;
    margin-top: 8%;
  }
  ul li:nth-child(4) > .ball {
    width: 100px;
    height: 100px;
    left: 11.3%;
    top: 11.3%;
    background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    opacity: 1;
    transform: rotate(120deg);
  }

  @keyframes orbit {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
}
</style>
